/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  LocationDto,
  SearchLocationParams
} from './model';

import { mutator } from '../mutator';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Search locations
 */
export const searchLocation = (
    params?: SearchLocationParams,
 options?: SecondParameter<typeof mutator>,signal?: AbortSignal
) => {


      return mutator<LocationDto[]>(
      {url: `/api/v1/locations/search`, method: 'GET',
        params, signal
    },
      options);
    }



export const getSearchLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchLocation>>, TError,{params?: SearchLocationParams}, TContext>, request?: SecondParameter<typeof mutator>}
): UseMutationOptions<Awaited<ReturnType<typeof searchLocation>>, TError,{params?: SearchLocationParams}, TContext> => {

const mutationKey = ['searchLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchLocation>>, {params?: SearchLocationParams}> = (props) => {
          const {params} = props ?? {};

          return  searchLocation(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchLocationMutationResult = NonNullable<Awaited<ReturnType<typeof searchLocation>>>

    export type SearchLocationMutationError = unknown

    /**
 * @summary Search locations
 */
export const useSearchLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchLocation>>, TError,{params?: SearchLocationParams}, TContext>, request?: SecondParameter<typeof mutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchLocation>>,
        TError,
        {params?: SearchLocationParams},
        TContext
      > => {
      return useMutation(getSearchLocationMutationOptions(options), queryClient);
    }
